import React from 'react';
import Popup from 'reactjs-popup';
import '../styles/givingConfirmModal.css';

const overlayStyle = { background: 'rgba(10, 13, 18, 0.5)' };
const contentStyle = {
  padding: 0,
  border: 'none',
  background: 'transparent',
  width: 'auto',
  boxShadow: 'none',
};

const GivingConfirmModal = ({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel = 'Cancel',
  pendingLabel,
  pending = false,
  danger = false,
  confirmDisabled = false,
  onConfirm,
  onCancel,
  children,
}) => (
  <Popup
    open={open}
    modal
    closeOnDocumentClick={!pending}
    closeOnEscape={!pending}
    onClose={onCancel}
    overlayStyle={overlayStyle}
    contentStyle={contentStyle}
    className="gconfirm-popup"
  >
    <div
      className="gconfirm-modal"
      role={danger ? 'alertdialog' : 'dialog'}
      aria-modal="true"
      aria-label={title}
    >
      <div className="gconfirm-header">
        <h2 className="gconfirm-title">{title}</h2>
        <button
          type="button"
          className="gconfirm-close"
          onClick={onCancel}
          disabled={pending}
          aria-label="Close"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <hr className="gconfirm-divider" />
      <div className="gconfirm-body">
        <p className="gconfirm-desc">{body}</p>
        {children}
      </div>
      <div className="gconfirm-footer">
        <button
          type="button"
          className="btn btn-setlist-secondary"
          onClick={onCancel}
          disabled={pending}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className={danger ? 'btn btn-danger' : 'btn btn-setlist-primary'}
          onClick={onConfirm}
          disabled={pending || confirmDisabled}
          autoFocus={!danger}
        >
          {pending ? pendingLabel : confirmLabel}
        </button>
      </div>
    </div>
  </Popup>
);

export default GivingConfirmModal;
